import { Text } from '@hopskipdrive/react-components';

export const getCalendarConflictOptions = (errorMessage: string) => ({
  title: 'Schedule this ride on a day off?',
  content: (
    <>
      <Text variant="body1" fontWeight={300} mb={4}>
        {errorMessage.replace(':', ',')}
      </Text>
      <Text variant="body1" fontWeight={300}>
        HopSkipDrive is open, however.
      </Text>
      <Text variant="body1" fontWeight={300}>
        Do you want to schedule this ride anyway?
      </Text>
    </>
  ),
});

export const getHopSkipDriveClosedOptions = (errorMessage: string) => ({
  title: 'This is a day off',
  content: (
    <>
      <Text variant="body1" fontWeight={300} mb={4}>
        {errorMessage.slice(errorMessage.indexOf('HopSkipDrive'))}
      </Text>
      <Text variant="body1" fontWeight={300}>
        Rides cannot be scheduled on this day.
      </Text>
    </>
  ),
});
